// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaV = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M11.953 15.708c-.294-.938-.602-1.918-.91-2.842L9.21 7.448H7.501v.574l3.374 9.478h2.142l3.5-9.478v-.574H14.88l-1.946 5.558c-.336.966-.574 1.764-.868 2.702z" />
  );
export default SvgIconAlphaV;
